<template>
  <div class="py-6 px-1 md:px-2 lg:px-6">
    <div class="mx-auto py-8 max-w-sm flex justify-center text-black">
            <span class="h-full">
                 <img src="/img/logo_kingmod.png" style="height: 100%; max-width: 100%; display: block; margin: auto;"/>
            </span>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'Auth',
}
</script>
